module.exports = __webpack_public_path__ + "img/newsImg11-4.001f5ea3.png";